import React from 'react';
import { compose, withPropsOnChange } from 'recompose';
import classnames from 'classnames';
import styles from '../../../../styles/widgets/adverts/adverts-widget.module.scss';
import { THeadline } from '../../../../components/template';
import { AdvertLink } from '../../../../components/advert';
import { withWidgetController } from '../../components/with-controller';
import { withGridContext } from '../../components/with-grid';
import { withWidgetTracking } from '../../hocs/with-widget-tracking';
import { AdvertLinkViewController } from './view';

const Component = React.memo(({ adverts, title, subtitle, groupName }) => (
  <>
    <THeadline className={styles.headline} title={title} subtitle={subtitle} />
    <AdvertLinkViewController advertName={`advert_${groupName}`}>
      {adverts.map(
        ({
          title,
          bodyText,
          imageUrl,
          backgroundImageUrl,
          foregroundImageUrl,
          inlineImageUrl,
          link,
          isExternal,
          styling,
          actions
        }) => (
          <AdvertLink
            key={title}
            titleAs='h3'
            title={title}
            body={bodyText}
            backgroundImageUrl={backgroundImageUrl}
            foregroundImageUrl={foregroundImageUrl}
            inlineImageUrl={inlineImageUrl}
            imageUrl={imageUrl}
            to={link}
            isExternal={isExternal}
            styling={styling}
            actions={actions}
          />
        )
      )}
    </AdvertLinkViewController>
  </>
));

Component.displayName = 'AdvertLinksComponent';

export const Widget = compose(
  withPropsOnChange([], ({ styling }) => ({
    className: classnames(styles.container, { [styles[styling]]: !!styling })
  })),
  withWidgetController(),
  withGridContext,
  withWidgetTracking
)(Component);

Widget.displayName = 'AdvertLinksWidget';
